<template>
  <div>
    <wrapper-filters
        title=""
        :sendFilterRequestAfterSelect="true"
        :showResetFilterButton="false"
        :showCollapseFilter="false"
        filtersUrl="/cabinet/partner/monetizestatistic/getDynamicList"
        filtersUrlMethod="get"
        :setEnabledFilters="{
          services: {
            enable: true,
            multiple: true,
            getDataLink: '/services/getList',
            placeholder: this.getLocalization('Services'),
            specifiedKeyForId: 'activate_org_code',
            column: 2,
          },
          countries: {
            enable: true,
            multiple: true,
            getDataLink: '/countries/getList',
            placeholder: this.getLocalization('Countries'),
            specifiedKeyForId: 'activate_org_code',
            column: 3,
          },
          dateSelector: {
            enable: true,
            placeholder: this.getLocalization('Period'),
            noGroupSelect: true,
            closeOnSelect: true,
            startWithRequest: true,
            selectedKey: 'dateSelector',
            data: [
                {
                  id: 3,
                  title: this.getLocalization('Last day')
                },
                {
                  id: 4,
                  title: this.getLocalization('Last week')
                },
                {
                  id: 5,
                  title: this.getLocalization('Last month')
                },
            ],
            column: 1,
          },
        }"
        @set-filtered-list="setFilteredList"
    >
    </wrapper-filters>
    <div class="wrapperCanvas mt-5">
      <LineChart
          v-if="loaded"
          :chart-data="chartData"
      ></LineChart>
    </div>

  </div>
</template>

<script>
import WrapperFilters from "../../../components/table/wrapperFilters";
import LineChart from "../../../components/LineChart/lineChart";
import GraphDynamic from "../../../components/mixins/GraphDynamicMixin";

export default {
  name: "dynamicTopUpStatistic",
  mixins: [
    GraphDynamic,
  ],
  props:[
    'translations'
  ],
  components: {
    WrapperFilters,
    LineChart
  },
}
</script>